import { render } from "./MdDropDownIcon.vue?vue&type=template&id=2a3e9ac4"
import script from "./MdDropDownIcon.vue?vue&type=script&lang=js"
export * from "./MdDropDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__